"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.heading.chat': 'Comienza a hablar con tu asistente IA',
    'chat.heading.ask': 'Haz tu pregunta',
};
